import { render } from "./NavigationBar.vue?vue&type=template&id=3cba8e86"
const script = {}

import exportComponent from "C:\\Users\\TOP\\Desktop\\vue\\nomad-poc-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__